<app-filter-container>
    <form [formGroup]="filterForm">
        <app-form-section>
            <app-form-row>
                <h1>{{ 'MENU.MEASUREMENT' | translate }}</h1>
                <app-form-group class="actionbuttons">
                    <button
                        *ngIf="hasIncludeFlags() && !isUnrestricted"
                        (click)="moveSelectedMeasurements($event)"
                        [disabled]="!allSelectedEditable() || isMoveLoading || isDeleteLoading"
                        type="button"
                    >
                        <span class="material-symbols-rounded leading">move_location</span>
                        {{ 'FEATURES.MEASUREMENTS.TITLES.MOVE_MEASUREMENTS' | translate }}
                    </button>
                    <button
                        *ngIf="hasIncludeFlags()"
                        (click)="confirmDeleteSelectedMeasurements($event)"
                        [disabled]="
                            !allSelectedEditable() ||
                            isDeleteLoading ||
                            isMoveLoading ||
                            loadingMeasurementIds.length > 0
                        "
                        type="button"
                    >
                        <span class="material-symbols-rounded leading" [class.spinner]="isDeleteLoading">{{
                            isDeleteLoading ? 'progress_activity' : 'delete'
                        }}</span>
                        {{ 'FEATURES.MEASUREMENTS.TITLES.DELETE_MEASUREMENTS' | translate }}
                    </button>
                    <button
                        *ngIf="hasIncludeFlags()"
                        (click)="exportSelected($event, exportType.Excel)"
                        [disabled]="downloading.excel"
                        type="button"
                    >
                        <span class="material-symbols-rounded leading" [class.spinner]="downloading.excel">{{
                            downloading.excel ? 'progress_activity' : 'table_view'
                        }}</span>
                        {{
                            downloading.excel
                                ? bulkExportProgress
                                    ? bulkExportProgress.processedFiles + '/' + bulkExportProgress.totalFiles
                                    : ('FEATURES.MEASUREMENTS.REPORT_ACTIONS.EXPORTING' | translate)
                                : ('FEATURES.MEASUREMENTS.REPORT_ACTIONS.EXPORT_EXCEL' | translate)
                        }}
                    </button>
                    <button
                        *ngIf="hasIncludeFlags()"
                        (click)="exportSelected($event, exportType.CSV)"
                        [disabled]="downloading.csv"
                        type="button"
                    >
                        <span class="material-symbols-rounded leading" [class.spinner]="downloading.csv">{{
                            downloading.csv ? 'progress_activity' : 'description'
                        }}</span>
                        {{
                            downloading.csv
                                ? bulkExportProgress
                                    ? bulkExportProgress.processedFiles + '/' + bulkExportProgress.totalFiles
                                    : ('FEATURES.MEASUREMENTS.REPORT_ACTIONS.EXPORTING' | translate)
                                : ('FEATURES.MEASUREMENTS.REPORT_ACTIONS.EXPORT_CSV' | translate)
                        }}
                    </button>
                    <button
                        *ngIf="hasIncludeFlagsAndPermission()"
                        (click)="exportRawData($event)"
                        [disabled]="downloading.rawData"
                        type="button"
                    >
                        <span class="material-symbols-rounded leading" [class.spinner]="downloading.rawData">{{
                            downloading.rawData ? 'progress_activity' : 'data_object'
                        }}</span>
                        {{
                            downloading.rawData
                                ? bulkExportProgress
                                    ? bulkExportProgress.processedFiles + '/' + bulkExportProgress.totalFiles
                                    : ('FEATURES.MEASUREMENTS.REPORT_ACTIONS.EXPORTING' | translate)
                                : ('FEATURES.MEASUREMENTS.REPORT_ACTIONS.DOWNLOAD_RAW_DATA' | translate)
                        }}
                    </button>
                    <button
                        *appHasPermissions="[permissions.ImportMeasurement]"
                        (click)="goToImportMeasurement()"
                        class="primary"
                        type="button"
                    >
                        {{ 'BUTTONS.IMPORT_MEASUREMENT' | translate }}
                        <span class="material-symbols-rounded trailing" aria-hidden="true"> add_2 </span>
                    </button>
                </app-form-group>
            </app-form-row>

            <div class="action-box">
                <div class="search-box">
                    <app-search-input formControlName="searchPhrase" />

                    <div class="actions">
                        <ng-container>
                            <div class="measurement-summary">
                                <span
                                    [appTooltip]="'FEATURES.MEASUREMENTS.TOOLTIPS.NUM_OF_MEASUREMENTS' | translate"
                                    [tooltipPosition]="'left'"
                                    class="material-symbols-rounded leading"
                                    aria-hidden="true"
                                >
                                    assessment
                                </span>
                                <span>{{ measurementsLength }}</span>
                            </div>
                        </ng-container>

                        <div ngbDropdown>
                            <button
                                ngbDropdownToggle
                                [appTooltip]="'FILTER.SAVED_FILTERS.TOOLTIPS.LOAD_FILTER' | translate"
                                [tooltipPosition]="'left'"
                                class="text"
                                type="button"
                            >
                                <span class="material-symbols-rounded leading" aria-hidden="true">bookmarks</span>
                                <span>{{ 'FILTER.SAVED_FILTERS.BUTTON_LABEL' | translate }}</span>
                            </button>
                            <div ngbDropdownMenu>
                                <div *ngIf="savedFilters.length === 0" class="dropdown-item disabled">
                                    {{ 'FILTER.SAVED_FILTERS.EMPTY' | translate }}
                                </div>
                                <div *ngFor="let sf of savedFilters" class="saved-filter-row">
                                    <button ngbDropdownItem (click)="applySavedFilter(sf)">{{ sf.name }}</button>
                                    <button
                                        class="saved-filter-delete"
                                        type="button"
                                        [appTooltip]="'FILTER.SAVED_FILTERS.TOOLTIPS.DELETE_TOOLTIP' | translate"
                                        [tooltipPosition]="'left'"
                                        (click)="deleteSavedFilter(sf, $event)"
                                    >
                                        <span class="material-symbols-rounded" aria-hidden="true">delete</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <button
                            [appTooltip]="'FILTER.SAVED_FILTERS.TOOLTIPS.SAVE_TOOLTIP' | translate"
                            [tooltipPosition]="'left'"
                            (click)="saveCurrentFilter()"
                            [disabled]="isFilterEmpty || savingFilter"
                            class="text"
                            type="button"
                        >
                            <span
                                class="material-symbols-rounded leading"
                                [class.spinner]="savingFilter"
                                aria-hidden="true"
                                >{{ savingFilter ? 'progress_activity' : 'bookmark_add' }}</span
                            >
                            <span>{{ 'FILTER.SAVED_FILTERS.SAVE_BUTTON' | translate }}</span>
                        </button>

                        <button
                            [appTooltip]="'FEATURES.MEASUREMENTS.TOOLTIPS.SHOW_HIDE_FILTER' | translate"
                            [tooltipPosition]="'left'"
                            (click)="showFilter = !showFilter"
                            [ngClass]="{ activated: !showFilter }"
                            class="text"
                            type="button"
                        >
                            <span class="material-symbols-rounded leading" aria-hidden="true"> filter_list </span>
                            <span>{{ 'BUTTONS.FILTER_TOGGLE_BUTTON' | translate }}</span>
                        </button>

                        <button *ngIf="!isFilterEmpty" (click)="clearFilter()" class="text" type="button">
                            <span>{{ 'BUTTONS.FILTER_CLEAR_FILTER' | translate }}</span>
                            <span class="material-symbols-rounded trailing" aria-hidden="true"> clear </span>
                        </button>

                        <button
                            (click)="showScorecardComparison = !showScorecardComparison"
                            [ngClass]="{ activated: showScorecardComparison }"
                            class="text"
                            type="button"
                        >
                            <span class="material-symbols-rounded leading" aria-hidden="true">query_stats</span>
                            <span>{{ 'FEATURES.SCORECARD.NAME' | translate }}</span>
                        </button>
                    </div>
                </div>
                <div class="filter-box">
                    <app-form-group>
                        <app-filter
                            [tableType]="tableType"
                            [config]="filterConfig"
                            [visible]="showFilter"
                            (filterChange)="onFilterChange($event)"
                            (isFilterEmptyChanged)="isFilterEmpty = $event"
                        ></app-filter>
                    </app-form-group>
                </div>
            </div>
        </app-form-section>
    </form>
</app-filter-container>

<div *ngIf="showScorecardComparison" class="scorecard-panel">
    <app-scorecard-comparison [useListFilter]="true" />
</div>

<div>
    <app-table [loading]="loading" [clickable]="true">
        <tr thead class="distinct">
            <app-table-header
                [align]="align.Center"
                [width]="5"
                [checkbox]="true"
                [appTooltip]="'FEATURES.MEASUREMENTS.TOOLTIPS.SELECT_ALL' | translate"
                (checkedChanged)="onCheckedAllChange($event)"
            />
            <app-table-header
                [isActive]="sortKey === 'capturedDate'"
                [defaultAscending]="sortKey === 'capturedDate' && sortAscending"
                [sort]="true"
                [width]="14"
                [text]="'FEATURES.MEASUREMENTS.COLUMNS.CAPTURED_DATE' | translate"
                (sortChanged)="onSortChange('capturedDate', $event)"
            />
            <app-table-header
                [isActive]="sortKey === 'created'"
                [defaultAscending]="sortKey === 'created' && sortAscending"
                [sort]="true"
                [width]="14"
                [text]="'FEATURES.MEASUREMENTS.COLUMNS.UPLOADED' | translate"
                (sortChanged)="onSortChange('created', $event)"
            />
            <app-table-header
                [isActive]="sortKey === 'user.firstName'"
                [defaultAscending]="sortKey === 'user.firstName' && sortAscending"
                [sort]="true"
                [width]="18"
                [text]="'FEATURES.MEASUREMENTS.COLUMNS.UPLOADED_BY' | translate"
                (sortChanged)="onSortChange('user.firstName', $event)"
            />
            <app-table-header
                *ngIf="isUnrestricted"
                [isActive]="sortKey === 'tenant.name'"
                [defaultAscending]="sortKey === 'tenant.name' && sortAscending"
                [sort]="true"
                [width]="14"
                [text]="'FEATURES.MEASUREMENTS.COLUMNS.TENANT' | translate"
                (sortChanged)="onSortChange('tenant.name', $event)"
            />
            <app-table-header
                [isActive]="sortKey === 'location.name'"
                [defaultAscending]="sortKey === 'location.name' && sortAscending"
                [sort]="true"
                [width]="12"
                [text]="'FEATURES.MEASUREMENTS.COLUMNS.LOCATION' | translate"
                (sortChanged)="onSortChange('location.name', $event)"
            />
            <app-table-header
                [isActive]="sortKey === 'ref'"
                [defaultAscending]="sortKey === 'ref' && sortAscending"
                [sort]="true"
                [width]="8"
                [text]="'FEATURES.MEASUREMENTS.COLUMNS.REF' | translate"
                (sortChanged)="onSortChange('ref', $event)"
            />
            <app-table-header
                [isActive]="sortKey === 'duration'"
                [defaultAscending]="sortKey === 'duration' && sortAscending"
                [sort]="true"
                [width]="12"
                [text]="'FEATURES.MEASUREMENTS.COLUMNS.DURATION' | translate"
                (sortChanged)="onSortChange('duration', $event)"
            />
            <app-table-header
                [isActive]="sortKey === 'softwareVersion'"
                [defaultAscending]="sortKey === 'softwareVersion' && sortAscending"
                [sort]="true"
                [width]="12"
                [text]="'FEATURES.MEASUREMENTS.COLUMNS.SOFTWARE_VERSION' | translate"
                (sortChanged)="onSortChange('softwareVersion', $event)"
            />
            <app-table-header
                [isActive]="sortKey === 'filter'"
                [defaultAscending]="sortKey === 'filter' && sortAscending"
                [sort]="true"
                [width]="12"
                [text]="'FEATURES.MEASUREMENTS.COLUMNS.FILTER' | translate"
                (sortChanged)="onSortChange('filter', $event)"
            />
            <app-table-header
                [isActive]="sortKey === 'device.serialNumber'"
                [defaultAscending]="sortKey === 'device.serialNumber' && sortAscending"
                [sort]="true"
                [width]="10"
                [text]="'FEATURES.MEASUREMENTS.COLUMNS.SERIAL_NUMBER' | translate"
                (sortChanged)="onSortChange('device.serialNumber', $event)"
            />
            <app-table-header
                [isActive]="sortKey === 'annotation'"
                [defaultAscending]="sortKey === 'annotation' && sortAscending"
                [sort]="true"
                [width]="14"
                [text]="'FEATURES.MEASUREMENTS.COLUMNS.ANNOTATIONS' | translate"
                [secondaryText]="'FEATURES.MEASUREMENTS.COLUMNS.ANNOTATIONS_MARKERS' | translate"
                (sortChanged)="onSortChange('annotation', $event)"
            />
            <app-table-header [align]="align.Center" [width]="12" />
        </tr>
        <ng-container tbody>
            <tr *ngFor="let item of measurements$ | async">
                <td class="action">
                    <app-checkbox
                        [ngModel]="includeFlags[item.id] || false"
                        (ngModelChange)="onIncludeToggle(item.id, $event)"
                    />
                </td>
                <td
                    (click)="navigateToMeasurement(item.id)"
                    [appTooltip]="item.capturedDate | dateTime: 'yyyy-MM-dd HH:mm'"
                >
                    {{ item.capturedDate | dateTime: 'yyyy-MM-dd HH:mm' | replaceEmptyString }}
                </td>
                <td (click)="navigateToMeasurement(item.id)" [appTooltip]="item.created | dateTime: 'yyyy-MM-dd HH:mm'">
                    {{ item.created | dateTime: 'yyyy-MM-dd HH:mm' | replaceEmptyString }}
                </td>
                <td (click)="navigateToMeasurement(item.id)" [appTooltip]="item.createdBy">{{ item.createdBy }}</td>
                <td *ngIf="isUnrestricted" (click)="navigateToMeasurement(item.id)" [appTooltip]="item.tenant">
                    {{ item.tenant }}
                </td>
                <td (click)="navigateToMeasurement(item.id)" [appTooltip]="item.location">{{ item.location }}</td>
                <td (click)="navigateToMeasurement(item.id)" [appTooltip]="item.ref">{{ item.ref }}</td>
                <td (click)="navigateToMeasurement(item.id)" [appTooltip]="item.duration">{{ item.duration }}</td>
                <td (click)="navigateToMeasurement(item.id)" [appTooltip]="item.softwareVersion">
                    {{ item.softwareVersion }}
                </td>
                <td (click)="navigateToMeasurement(item.id)" [appTooltip]="item.filter.toString()">
                    {{ item.filter }}
                </td>
                <td (click)="navigateToMeasurement(item.id)" [appTooltip]="item.serialNumber">
                    {{ item.serialNumber }}
                </td>
                <td
                    (click)="navigateToMeasurement(item.id)"
                    [appTooltip]="item.annotation"
                    [tooltipPosition]="'left'"
                    [tooltipDisabled]="!item.annotation"
                >
                    {{ !item.annotation && item.markers?.length > 0 ? '-' : item.annotation }}<br />
                    <span class="secondary" *ngIf="item.markers?.length">{{ getMarkerAnnotationText(item) }}</span>
                </td>
                <td class="center">
                    <button *ngIf="item.isEditable" (click)="openMarkerAnnotation(item)" class="icon">
                        <span class="material-symbols-rounded" aria-label="Edit"> edit </span>
                    </button>
                    <button
                        *ngIf="item.isEditable"
                        (click)="confirmDeleteMeasurement($event, item)"
                        class="icon"
                        [ngClass]="{ loading: loadingMeasurementIds.includes(item.id) }"
                    >
                        <span class="material-symbols-rounded" aria-label="Delete"> delete </span>
                    </button>
                </td>
            </tr>
        </ng-container>
    </app-table>

    <app-pagination
        [currentPage]="currentPage"
        [pageSize]="pageSize"
        [total]="measurementsLength"
        [disabled]="loading"
        (pageChange)="onPaginationChange($event)"
    ></app-pagination>
</div>
